export default "__VITE_ASSET__Be6i2Q5c__"